import type { IconNode } from '../types';

/**
 * @name face-alien
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTJhNy44NSA3Ljg1IDAgMCAxLTMuNyA2LjZsLTQgMi43YTMuOSAzLjkgMCAwIDEtNC41IDBsLTQtMi43QTcuNTcgNy41NyAwIDAgMSAyIDEyYTEwIDEwIDAgMCAxIDIwIDAiIC8+CiAgPHBhdGggZD0iTTEwLjcgMTEuM2MtMS40LTEuMy0zLjMtMS43LTQuMi0uOHMtLjUgMi44LjggNC4yYzEuNCAxLjQgMy4yIDEuOCA0LjIuOC45LS45LjUtMi44LS44LTQuMiIgLz4KICA8cGF0aCBkPSJNMTcuNSAxMC41Yy0uOS0uOS0yLjgtLjUtNC4yLjgtMS40IDEuNC0xLjggMy4yLS44IDQuMi45LjkgMi44LjUgNC4yLS44IDEuMy0xLjQgMS43LTMuMy44LTQuMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/face-alien
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const faceAlien: IconNode = [
  [
    'path',
    {
      d: 'M22 12a7.85 7.85 0 0 1-3.7 6.6l-4 2.7a3.9 3.9 0 0 1-4.5 0l-4-2.7A7.57 7.57 0 0 1 2 12a10 10 0 0 1 20 0',
      key: 'ujp18h',
    },
  ],
  [
    'path',
    {
      d: 'M10.7 11.3c-1.4-1.3-3.3-1.7-4.2-.8s-.5 2.8.8 4.2c1.4 1.4 3.2 1.8 4.2.8.9-.9.5-2.8-.8-4.2',
      key: 'xfn8bp',
    },
  ],
  [
    'path',
    {
      d: 'M17.5 10.5c-.9-.9-2.8-.5-4.2.8-1.4 1.4-1.8 3.2-.8 4.2.9.9 2.8.5 4.2-.8 1.3-1.4 1.7-3.3.8-4.2',
      key: '1khjiu',
    },
  ],
];

export default faceAlien;
